import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getTemplatedGenericBenefits = () =>
  call(websocketFetch, 'get_templated_generic_benefits');
